import { notification } from 'antd';
import { useForm } from 'antd/lib/form/Form';
import { useState } from 'react';
import { useCreateEducationClassMutation } from 'shared/api';
import type { EducationClass } from 'shared/api';
import type { EducationClassFormValues } from 'entities/education-class/form';

export const useCopyEducationClass = (selectedEducationClass: EducationClass) => {
  const [form] = useForm<EducationClassFormValues>();

  const [createEducationClass, { isLoading }] = useCreateEducationClassMutation();

  const [visible, setVisible] = useState(false);

  const onSubmit = () => {
    form.validateFields().then((values) => {
      createEducationClass({
        ...values,
        includeSaturday: values.includeSaturday ?? false,
        saturdayMorningShift: values.saturdayMorningShift ?? false,
      })
        .unwrap()
        .then(() => {
          hideModal();
        })
        .catch((error) => {
          notification.error({ message: 'Не удалось создать класс' });
          throw error;
        });
    });
  };

  const showModal = () => {
    if (selectedEducationClass) {
      form.setFieldsValue({ ...selectedEducationClass });
    }
    setVisible(true);
  };

  const hideModal = () => {
    setVisible(false);
    form.resetFields();
  };

  return {
    state: {
      form,
      isLoading,
      visible,
    },
    methods: {
      onSubmit,
      showModal,
      hideModal,
    },
  };
};
